import { HubFeature } from "@ats/api/cm";
import { LocDefs, MapLocKeys } from "@cm/core/localization";

const dpRoot = 'Profile|My Information'

export type MyInformationLoc = 
    | 'CPProfileMyInformationLabelDataProvider';

export const myInformationLocs: LocDefs<MyInformationLoc> = {
    CPProfileMyInformationLabelDataProvider: {
        defaultValue: 'Certmetrics',
        description: 'Label for data provider.',
        displayPath: `${dpRoot}|Data Provider`,
        displayType: 'Label',
        feature: HubFeature.CandidateProfileExternalIds,
        portal: 'CP',
    },
};

export const LOC_KEYS = MapLocKeys<MyInformationLoc>(myInformationLocs);
